



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<SearchBar>({
	watch: {
		keywords: function (newVal: string): void {
			this.$emit("input", newVal);
		},
		open: function (newVal: boolean): void {
			if (newVal) {
				this.$nextTick(() => {
					(this.$refs.search_input as any).focus()
				})
			}
		},
	}
})
export default class SearchBar extends Vue {
	//@ts-ignore
	@Prop() value: string;
	private keywords: string = "";
	public open = false;
}
